import { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const form = e.target as HTMLFormElement;
    const honeypot = (form.elements.namedItem('website_alt') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setSubmitted(true);
      return;
    }

    const formData = new URLSearchParams();
    formData.append('email', email);

    try {
      await fetch('https://readdy.ai/api/form/d91nqmvefssur58kqnl0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString(),
      });
    } catch {
      // silently handle submission error
    }

    setSubmitted(true);
    setEmail('');
  };

  return (
    <footer className="bg-accent-900 text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.04]">
        <div className="w-full h-full" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
        }}></div>
      </div>

      <div className="relative z-10 px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">

            <div className="flex-1">
              <Link to="/" className="font-heading text-2xl font-bold tracking-tight whitespace-nowrap">
                pandabuy<span className="text-primary-400">.</span>bar
              </Link>

              <form
                data-readdy-form
                onSubmit={handleSubmit}
                className="mt-6 flex items-center gap-2"
              >
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Your email for updates"
                  required
                  className="flex-1 bg-white/10 border border-white/20 rounded-full px-4 py-2.5 text-sm text-white placeholder:text-white/40 outline-none focus:border-primary-400 transition-colors"
                />
                <input
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  className="contact-hp-field"
                />
                <button
                  type="submit"
                  className="w-10 h-10 rounded-full bg-primary-500 flex items-center justify-center text-white hover:bg-primary-400 transition-colors flex-shrink-0 cursor-pointer"
                  aria-label="Subscribe"
                >
                  <i className="ri-notification-line text-lg"></i>
                </button>
              </form>

              {submitted && (
                <p className="mt-3 text-xs text-green-400">Thanks for subscribing! We will keep you updated.</p>
              )}

              <p className="mt-6 font-heading text-xl md:text-2xl text-white/80 leading-snug">
                Your curated<br />
                shopping gateway
              </p>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-8 flex-[2]">
              <div>
                <h4 className="text-sm font-semibold text-white/50 uppercase tracking-wider mb-4">Categories</h4>
                <div className="space-y-2.5">
                  {categories.slice(0, 5).map((cat) => (
                    <a
                      key={cat.seq}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="block text-sm text-white/70 hover:text-white transition-colors whitespace-nowrap"
                    >
                      {cat.name}
                    </a>
                  ))}
                </div>
              </div>
              <div>
                <h4 className="text-sm font-semibold text-white/50 uppercase tracking-wider mb-4">More</h4>
                <div className="space-y-2.5">
                  {categories.slice(5, 10).map((cat) => (
                    <a
                      key={cat.seq}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="block text-sm text-white/70 hover:text-white transition-colors whitespace-nowrap"
                    >
                      {cat.name}
                    </a>
                  ))}
                </div>
              </div>
              <div>
                <h4 className="text-sm font-semibold text-white/50 uppercase tracking-wider mb-4">Also</h4>
                <div className="space-y-2.5">
                  {categories.slice(10).map((cat) => (
                    <a
                      key={cat.seq}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="block text-sm text-white/70 hover:text-white transition-colors whitespace-nowrap"
                    >
                      {cat.name}
                    </a>
                  ))}
                </div>
              </div>
              <div>
                <h4 className="text-sm font-semibold text-white/50 uppercase tracking-wider mb-4">Links</h4>
                <div className="space-y-2.5">
                  <Link to="/pandabuy-sheet-ultimate-guide" className="block text-sm text-white/70 hover:text-white transition-colors whitespace-nowrap">
                    Ultimate Guide
                  </Link>
                  <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="block text-sm text-white/70 hover:text-white transition-colors whitespace-nowrap">
                    Pandabuy Sheet
                  </a>
                  <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="block text-sm text-white/70 hover:text-white transition-colors whitespace-nowrap">
                    Main Store
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-white/40">
              &copy; {new Date().getFullYear()} pandabuy.bar. All rights reserved.
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 rounded-lg border border-white/20 flex items-center justify-center text-white/60 hover:text-white hover:border-white/40 transition-colors cursor-pointer" aria-label="Twitter">
                <i className="ri-twitter-x-line"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg border border-white/20 flex items-center justify-center text-white/60 hover:text-white hover:border-white/40 transition-colors cursor-pointer" aria-label="Instagram">
                <i className="ri-instagram-line"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg border border-white/20 flex items-center justify-center text-white/60 hover:text-white hover:border-white/40 transition-colors cursor-pointer" aria-label="TikTok">
                <i className="ri-tiktok-line"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg border border-white/20 flex items-center justify-center text-white/60 hover:text-white hover:border-white/40 transition-colors cursor-pointer" aria-label="Reddit">
                <i className="ri-reddit-line"></i>
              </a>
            </div>
            <a href="#" className="text-sm text-white/40 hover:text-white/70 transition-colors whitespace-nowrap">
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}